import { CurrencyInput, HintText, Label } from "@components";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { ConfigModuleSetting } from "./configuration/types";

type FormValues = Pick<
	ConfigModuleSetting,
	"initialCorrectionAmount" | "category"
>;

export default function BugetCorrectionSetting() {
	const { control, watch } = useFormContext<FormValues>();

	const category = watch("category");
	if (category !== "mobility") {
		return null;
	}

	const initialCorrectionAmount = watch("initialCorrectionAmount");

	return (
		<div>
			<div style={{ display: "flex", marginBottom: "0.25rem" }}>
				<Label
					style={{ paddingLeft: 0, width: "max-content", flex: "unset" }}
					htmlFor="initialCorrectionAmount"
					column
					sm="3"
				>
					Einmaliger Korrekturwert
				</Label>
				<Controller
					name="initialCorrectionAmount"
					control={control}
					render={({ field }) => (
						<CurrencyInput
							style={{ width: 200 }}
							{...field}
							allowNull
							min={-Infinity}
							id="initialCorrectionAmount"
						/>
					)}
				/>
			</div>

			{initialCorrectionAmount !== 0 && initialCorrectionAmount !== null && (
				<HintText style={{ marginTop: "0.5rem" }}>
					Beeinflusst den Betrag <strong>des ersten Monatsbudgets</strong> im
					angegebenen Zeitraum. Kann negativ sein. Falls der Gesamtbetrag (Max.
					monatlicher Betrag + Korrekturwert) negativ ist, sollte das
					Überschussbudget aktiviert werden, damit der negative Betrag in den
					Folgemonat übertragen und mit der Zeit abgegolten werden kann.
				</HintText>
			)}
		</div>
	);
}
